/**
 * A small label naming the WhatsApp (QR) number a chat belongs to (the contact's own number, or a group's own number).
 * Shown on every QR chat -- in the inbox list and the chat header -- even with a single number. Renders nothing for chats
 * that are not on a QR number (Meta / Instagram / Facebook), or when the number is unknown.
 */
import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

const ChatNumberBadge = ({ connectionId, sx }) => {
  const connections = useSelector((s) => s.workspace?.currentWorkspace?.whatsappQrConnections);
  // Shown for every QR chat, even when the workspace has a single number, so the number's name is always visible.
  // Chats with no QR number (Meta, Instagram, Facebook) have no connectionId and show nothing.
  if (!connectionId || !Array.isArray(connections) || connections.length < 1) return null;
  const conn = connections.find((c) => c.connectionId === String(connectionId));
  if (!conn) return null;
  return (
    <Box
      component="span"
      title={`WhatsApp number: ${conn.label || conn.phoneNumber || ""}`}
      sx={{
        flexShrink: 0,
        maxWidth: 110,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "0.6875rem",
        lineHeight: 1.4,
        fontWeight: 500,
        px: 0.75,
        borderRadius: "6px",
        color: "text.secondary",
        bgcolor: (theme) => theme.palette.action.selected,
        ...sx,
      }}
    >
      {conn.label || conn.phoneNumber}
    </Box>
  );
};

export default ChatNumberBadge;
